export const parseChecksum = (res) => {
    const checksum = res.headers.get('etag')?.replace(/"/g, '');
    return checksum;
};
